import filters from '../features/filters';
import {register} from '../vendor/theme-scripts/theme-sections';

register('search-template', filters);
